// Re-export for relative path imports (e.g., "../vis-network/peer")
export { Network, parseDOTNetwork, parseGephi as parseGephiNetwork } from "./peer/esm/vis-network.mjs";
